module.exports = __webpack_public_path__ + "img/GE.81deeebc.svg";